import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  ladIndicator:Subject<boolean> = new Subject();

  constructor() { 
    this.ladIndicator.next(false);
  }

  start() {
    this.ladIndicator.next(true);
  }

  close() {
    this.ladIndicator.next(false);
  }
}